var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStoreIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64804 37.7444C7.32668 37.7501 7.00533 37.6953 6.70287 37.5818L21.9276 22.3514L26.9673 27.3967L9.47222 37.2265C8.9181 37.5514 8.29025 37.7297 7.64804 37.7444ZM5.44769 36.4873C5.1382 35.9268 4.98418 35.2938 5.00157 34.6537V6.85631C4.99901 6.43435 5.0628 6.01461 5.1906 5.61246L20.7537 21.1794L5.44202 36.4911L5.44769 36.4873ZM28.4701 26.5479L23.0997 21.1813L29.0221 15.2607L34.2829 18.2153C35.2923 18.669 35.9691 19.6425 36.0371 20.7465C36.0036 21.2888 35.8222 21.8116 35.5126 22.2581C35.203 22.7047 34.7771 23.0579 34.281 23.2796L28.4701 26.5479ZM21.9276 20.0017L6.16224 4.23819C6.59512 3.91683 7.11875 3.7467 7.65749 3.74481C8.29265 3.7675 8.91268 3.94708 9.46276 4.26844L27.5174 14.4158L21.9295 20.0017H21.9276Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreIconWhite);
export default __webpack_public_path__ + "static/media/play-store-icon-white.a52370fa1ae844071104f4f1c1cff70d.svg";
export { ForwardRef as ReactComponent };